// context/DrugsContext.js
import React, { createContext, useContext, useState, useCallback } from "react";
import { fetchDrugs } from "../utils/patients/dashboard/fetchDrugs";
import { fetchDrugMart } from "../utils/patients/dashboard/fetchDrugMart";
import { sendRequest } from "../utils/patients/sendRequest";
import { queryDrugs } from "../utils/patients/queryDrugs";
import useProfileStore from "../store/patient/profileStore";
import { useAuth } from "./AuthContext";

const DrugsContext = createContext(null);

export const DrugsProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [drugs, setDrugs] = useState([]);
  const [drugMart, setDrugMart] = useState([]);

  const { profile } = useProfileStore();
  const { user } = useAuth();

  const handleFetchDrugs = useCallback(async () => {
    const patientId = user?.id || profile?.id;
    if (!patientId) return;
    setLoading(true);
    try {
      const res = await fetchDrugs(patientId);
      setDrugs(res?.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [user?.id, profile?.id]);

  const handleQueryMart = useCallback(async (data, prof) => {
    setLoading(true);
    try {
      const res = await queryDrugs(data, prof);
      setDrugMart(res?.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleFetchDrugMart = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchDrugMart();
      setDrugMart(response.data);
      console.log(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSubmitRequest = useCallback(
    async (id, request_type, payload, note) => {
      setLoading(true);
      try {
        const response = await sendRequest(id, request_type, payload, note);
        return response;
      } catch (err) {
        console.error("error submitting request", err);
        if (err?.response?.status === 401) {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          localStorage.removeItem("tokenV2");
          localStorage.removeItem("userId");
          window.location.href = "/pages/signin2";
        }
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return (
    <DrugsContext.Provider
      value={{
        handleFetchDrugMart,
        handleFetchDrugs,
        handleQueryMart,
        handleSubmitRequest,
        drugMart,
        drugs,
        loading,
      }}
    >
      {children}
    </DrugsContext.Provider>
  );
};

// Custom hook
export const useDrugs = () => {
  const context = useContext(DrugsContext);
  if (!context) {
    throw new Error("useDrugs must be used within a DrugsProvider");
  }
  return context;
};
